import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Layout from '../components/Layout';
import Seo from '../components/Seo';
import { priceGuideList } from '../data/prices';

export default function Priser() {
  const guides = priceGuideList();
  return (
    <Layout>
      <Seo
        title="Prisguider for private behandlinger i Norge | Specialists.no"
        description="Se typiske priser for botox, fillers, hårtransplantasjon, tannbleking og andre private behandlinger i Norge."
        canonical="https://specialists.no/priser"
      />
      <section className="bg-[#0A1F44] text-white py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[#3B82F6] mb-3">PRISGUIDER 2025</div>
          <h1 className="font-display text-4xl lg:text-5xl font-bold">Hva koster private behandlinger i Norge?</h1>
          <p className="text-white/70 mt-4 text-lg max-w-2xl">Oppdaterte priser for 10 populære behandlinger — med by-for-by sammenligning.</p>
        </div>
      </section>
      <section className="py-12 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {guides.map((g) => (
              <Link key={g.slug} to={`/priser/${g.slug}`} className="group bg-white rounded-2xl p-6 border border-[#0A1F44]/10 hover:border-[#0A1F44]/30 hover:-translate-y-1 transition-all">
                <div className="text-[10px] uppercase tracking-[0.15em] font-semibold text-[#3B82F6] mb-2">{g.category}</div>
                <div className="font-display text-2xl font-bold text-[#0A1F44] mb-2">{g.treatment}</div>
                <div className="text-[#3B82F6] font-semibold">{g.ranges.typical}</div>
                <div className="mt-4 flex items-center gap-1 text-sm text-[#0A1F44] font-semibold group-hover:text-[#3B82F6]">Se prisguide <ArrowRight size={14} /></div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
